import Cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;
export const setCookie = (key, value) => {
    // let inTenHours = new Date(new Date().getTime() + 600 * 60 * 1000);
    let duration = 90; //In Days
    let expiresIn = new Date(new Date().getTime() + duration * 24 * 60 * 60 * 1000);
    Cookies.set(key, value, {
            domain: DOMAIN_NAME,
            expires: expiresIn
        }
    );
}

export const clearCookie = (key) => {
    Cookies.remove(key, 
        { domain: DOMAIN_NAME }
    );
}

export const isLogin = () => {
    if (Cookies.get('email') && Cookies.get('payload')) {
        return true;
    } else {
        return false;
    }
}

export const getPrivileges = () => {
    if (Cookies.get('payload')) {
        let decoded = jwt_decode(Cookies.get('payload'));
        if (parseInt(decoded.agency_id) !== parseInt(sessionStorage.getItem('agency_id'))) {
            return [];
        } else {
            let privileges = decoded.privilege;
            return privileges;
        }
    } else {
        return [];
    }
}

export const getUserDetails = () => {
    if (Cookies.get('payload')) {
        let userdetails = jwt_decode(Cookies.get('payload'));
        return userdetails;
    }
}